import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import classNames from 'classnames';
import get from 'lodash/get';
import Translate from '@client/components/shared/translation/Translate';
import Spinner from '../../shared/spinner/Spinner';
import { CloseIcon } from '../../shared/SvgIcons';
import styles from './styles.scss';


export class InfoBox extends PureComponent {
    static defaultProps = {
        iconComponent: null,
        onCloseClick: null,
        noCloseIcon: false,
        sticky: false,
        inline: false,
        pending: false
    }

    contentRef = React.createRef();

    render() {
        const {
            title,
            iconComponent,
            children,
            onCloseClick,
            noCloseIcon,
            sticky,
            inline,
            pending
        } = this.props;

        return (
            <div styleName={classNames('wrapper', { sticky, inline })}>
                { !noCloseIcon && <div styleName="close" onClick={onCloseClick}><CloseIcon styleName="close-icon" /></div> }
                { !pending ?
                    <div styleName="wrapper-inner" ref={this.contentRef}>
                        { iconComponent &&
                            <div styleName={classNames('icon-section', { inline })}>
                                { iconComponent }
                            </div>
                        }
                        <div styleName={classNames('content-section', { sticky, inline })}>
                            <span styleName="title">
                                <Translate message={title} html />
                            </span>
                            <div styleName="content">
                                { children }
                            </div>
                        </div>
                    </div>
                    :
                    <div styleName="loader-wrapper" style={this.getLoaderHeight()}>
                        <div styleName="loader"><Spinner /></div>
                    </div>
                }
            </div>
        );
    }

    getLoaderHeight = () => ({
        height: get(this, 'contentRef.current') ? `${this.contentRef.current.clientHeight}px` : 'auto'
    })
}

InfoBox.contentRef = React.createRef();

InfoBox.propTypes = {
    noCloseIcon: PropTypes.bool,
    title: PropTypes.string.isRequired,
    children: PropTypes.element.isRequired,
    iconComponent: PropTypes.element,
    onCloseClick: PropTypes.func,
    sticky: PropTypes.bool,
    pending: PropTypes.bool
};

export default CSSModules(InfoBox, styles, { allowMultiple: true });
